import React from "react"
import Link from "gatsby-link"
import Img from "gatsby-image"
import Markdown from "../../components/Markdown"
import { formatDateLong, formatTime } from "../../utils/utils"

import style from "./index.module.css";

export default class ArticleList extends React.Component {
  render() {
    var articles = this.props.articles;
    return (
      <div className={style.list}>
        {articles.edges && articles.edges.map(({ node }, index) => {
          return (
            <article key={index} className={style.item}>
              <a href={node.link} target="_blank">
                <Img className={style.image} sizes={node.image.sizes} />
                <h1 className={style.title}>{node.title}</h1>
                <Markdown source={node.description.description} />
              </a>
            </article>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticleList/index.js